// frontend/src/data/products.js

export const PRICE_MAP = {
  // Dairy
  milk: 40,
  "almond milk": 90,
  "soy milk": 70,
  cheese: 120,
  paneer: 90,
  curd: 35,
  butter: 55,
  yoghurt: 45,
  ghee: 90,

  // Fruits
  apple: 15,
  apples: 15,
  banana: 10,
  bananas: 10,
  orange: 12,
  oranges: 12,
  mango: 50,
  watermelon: 60,
  grapes: 40,
  strawberry: 80,
  strawberries: 80,

  // Vegetables
  potato: 30,
  potatoes: 30,
  onion: 35,
  onions: 35,
  tomato: 40,
  tomatoes: 40,
  spinach: 25,
  carrots: 30,
  peas: 40,
  cucumber: 20,
  ginger: 20,
  garlic: 35,

  // Bakery
  bread: 35,
  "brown bread": 45,
  "gluten free bread": 80,
  buns: 30,
  cake: 200,
  cookies: 60,

  // Snacks
  chips: 20,
  "baked chips": 30,
  popcorn: 25,
  biscuit: 25,
  biscuits: 25,
  namkeen: 50,
  noodles: 30,
  "instant noodles": 30,
  chocolate: 80,
  chocolates: 80,

  // Beverages
  tea: 15,
  coffee: 20,
  juice: 40,
  juices: 40,
  soda: 45,
  "cold drinks": 45,
  "soft drinks": 45,
  "coconut water": 40,
  buttermilk: 25,

  // Staples
  rice: 70,
  flour: 45,
  sugar: 50,
  jaggery: 40,
  honey: 110,
  salt: 20,
  oil: 140,
  "pakora mix": 45,

  // Others
  soup: 60,
  soups: 60,
  sweets: 150,
  "dry fruits": 120,
};

export const CATEGORY_KEYWORDS = {
  Dairy: ["milk", "almond milk", "soy milk", "cheese", "paneer", "curd", "butter", "yoghurt", "ghee"],
  Fruits: ["apple", "apples", "banana", "bananas", "orange", "oranges", "mango", "watermelon", "grapes", "strawberry", "strawberries"],
  Vegetables: ["potato", "potatoes", "onion", "onions", "tomato", "tomatoes", "spinach", "carrots", "peas", "cucumber", "ginger", "garlic"],
  Bakery: ["bread", "brown bread", "gluten free bread", "buns", "cake", "cookies"],
  Snacks: ["chips", "baked chips", "popcorn", "biscuit", "biscuits", "namkeen", "noodles", "instant noodles", "chocolate", "chocolates"],
  Beverages: ["tea", "coffee", "juice", "juices", "soda", "cold drinks", "soft drinks", "coconut water", "buttermilk"],
  "Grocery/Staples": ["rice", "flour", "sugar", "salt", "oil", "jaggery", "honey", "pakora mix"],
};

export const SMART_SUGGESTIONS_MAP = {
  milk: ["bread", "eggs", "cookies"],
  bread: ["butter", "jam", "cheese"],
  chips: ["soda", "popcorn"],
  tea: ["biscuits", "sugar"],
  coffee: ["cookies", "chocolates"],
  rice: ["oil", "salt"],
  sugar: ["tea", "coffee"],
  mango: ["ice cream", "curd"],
};

export const SUBSTITUTE_MAP = {
  milk: ["almond milk", "soy milk"],
  bread: ["brown bread", "gluten free bread"],
  butter: ["ghee", "margarine"],
  sugar: ["honey", "jaggery"],
  chips: ["baked chips", "popcorn"],
  coffee: ["tea"],
  rice: ["flour"],
};

// Month index: 0 = Jan ... 11 = Dec
export const SEASONAL_MAP = {
  0: ["oranges", "carrots", "peas", "soup", "dry fruits"],
  1: ["strawberries", "spinach", "sweet potato", "peanuts", "milk"],
  2: ["watermelon", "lemon", "cucumber", "mango", "juices"],
  3: ["mango", "curd", "ice cream", "cold drinks", "buttermilk"],
  4: ["mango", "ice cream", "cold drinks", "coconut water", "curd"],
  5: ["buttermilk", "cucumber", "lemon", "watermelon", "mint"],
  6: ["ginger", "tea", "coffee", "noodles", "soups"],
  7: ["corn", "pakora mix", "tea", "ginger", "biscuits"],
  8: ["soups", "coffee", "instant noodles", "chips", "tea"],
  9: ["sweets", "dry fruits", "ghee", "snacks", "cookies"],
  10: ["dry fruits", "sweets", "snacks", "ghee", "chocolates"],
  11: ["cake", "cookies", "chocolates", "soft drinks", "dry fruits"],
};
export const PRODUCT_CATALOG = [
  // Fruits
  { name: "apples", brand: "FreshFarm", category: "Fruits", price: 40, tags: ["organic"] },
  { name: "apples", brand: "NatureBasket", category: "Fruits", price: 60, tags: ["organic", "premium"] },
  { name: "banana", brand: "FreshFarm", category: "Fruits", price: 30, tags: [] },
  { name: "orange", brand: "CitrusKing", category: "Fruits", price: 45, tags: [] },
  { name: "mango", brand: "Alphonso", category: "Fruits", price: 120, tags: ["seasonal", "premium"] },
  { name: "watermelon", brand: "SummerFresh", category: "Fruits", price: 80, tags: ["seasonal"] },
  { name: "grapes", brand: "VineFresh", category: "Fruits", price: 70, tags: [] },
  { name: "apples", brand: "Kashmir Fresh", category: "Fruits", price: 55, tags: ["organic"] },
  { name: "apples", brand: "Regular Basket", category: "Fruits", price: 35, tags: [] },

  // Organic fruits (to support "organic <fruit>")
{ name: "oranges", brand: "NatureBasket", category: "Fruits", price: 65, tags: ["organic"] },
{ name: "banana", brand: "OrganicFarm", category: "Fruits", price: 45, tags: ["organic"] },
{ name: "mango", brand: "OrganicFarm", category: "Fruits", price: 150, tags: ["organic", "seasonal"] },
{ name: "grapes", brand: "OrganicFarm", category: "Fruits", price: 95, tags: ["organic"] },

// Organic vegetables
{ name: "tomato", brand: "OrganicFarm", category: "Vegetables", price: 55, tags: ["organic"] },
{ name: "onion", brand: "OrganicFarm", category: "Vegetables", price: 60, tags: ["organic"] },
{ name: "potato", brand: "OrganicFarm", category: "Vegetables", price: 50, tags: ["organic"] },
{ name: "carrots", brand: "OrganicFarm", category: "Vegetables", price: 45, tags: ["organic"] },



  // Vegetables
  { name: "tomato", brand: "VeggieMart", category: "Vegetables", price: 35, tags: [] },
  { name: "onion", brand: "VeggieMart", category: "Vegetables", price: 40, tags: [] },
  { name: "potato", brand: "FarmPick", category: "Vegetables", price: 30, tags: [] },
  { name: "spinach", brand: "GreenLeaf", category: "Vegetables", price: 25, tags: ["organic"] },
  { name: "carrots", brand: "FarmPick", category: "Vegetables", price: 30, tags: [] },
  { name: "cucumber", brand: "GreenLeaf", category: "Vegetables", price: 20, tags: [] },
  { name: "ginger", brand: "SpiceHub", category: "Vegetables", price: 20, tags: [] },

  // Dairy
  { name: "milk", brand: "Amul", category: "Dairy", price: 40, tags: [] },
  { name: "milk", brand: "Mother Dairy", category: "Dairy", price: 42, tags: [] },
  { name: "almond milk", brand: "SoGood", category: "Dairy", price: 90, tags: ["healthy"] },
  { name: "soy milk", brand: "Sofit", category: "Dairy", price: 75, tags: ["healthy"] },
  { name: "curd", brand: "Amul", category: "Dairy", price: 35, tags: [] },
  { name: "paneer", brand: "Amul", category: "Dairy", price: 90, tags: [] },
  { name: "cheese", brand: "Britannia", category: "Dairy", price: 120, tags: [] },
  { name: "butter", brand: "Amul", category: "Dairy", price: 55, tags: [] },

  // Eggs (Basics)
{ name: "eggs", brand: "FarmFresh", category: "Essentials", price: 6, tags: [] },
{ name: "eggs", brand: "OrganicFarm", category: "Essentials", price: 10, tags: ["organic"] },

// Jam
{ name: "jam", brand: "Kissan", category: "Grocery/Staples", price: 65, tags: [] },

// Ice cream
{ name: "ice cream", brand: "Amul", category: "Snacks", price: 60, tags: ["seasonal"] },

// Biscuits (extra)
{ name: "biscuits", brand: "Parle-G", category: "Snacks", price: 25, tags: [] },
{ name: "biscuits", brand: "GoodDay", category: "Snacks", price: 35, tags: ["premium"] },

// Soup packets
{ name: "soups", brand: "Knorr", category: "Grocery/Staples", price: 60, tags: [] },

// Toothbrush
{ name: "toothbrush", brand: "Colgate", category: "Personal Care", price: 30, tags: [] },

// Face wash
{ name: "face wash", brand: "Himalaya", category: "Personal Care", price: 110, tags: ["herbal"] },


  // Bakery
  { name: "bread", brand: "Britannia", category: "Bakery", price: 35, tags: [] },
  { name: "brown bread", brand: "Modern", category: "Bakery", price: 45, tags: ["healthy"] },
  { name: "gluten free bread", brand: "HealthyBakes", category: "Bakery", price: 80, tags: ["gluten-free"] },
  { name: "buns", brand: "Modern", category: "Bakery", price: 30, tags: [] },
  { name: "cookies", brand: "Oreo", category: "Bakery", price: 60, tags: ["snack"] },
  { name: "cake", brand: "BakeHouse", category: "Bakery", price: 200, tags: ["premium"] },

  // Snacks
  { name: "chips", brand: "Lays", category: "Snacks", price: 20, tags: ["small"] },
  { name: "chips", brand: "Bingo", category: "Snacks", price: 20, tags: ["small"] },
  { name: "baked chips", brand: "TooYumm", category: "Snacks", price: 30, tags: ["healthy"] },
  { name: "popcorn", brand: "Act II", category: "Snacks", price: 25, tags: [] },
  { name: "namkeen", brand: "Haldiram", category: "Snacks", price: 50, tags: [] },
  { name: "instant noodles", brand: "Maggi", category: "Snacks", price: 30, tags: [] },
  { name: "chocolates", brand: "Dairy Milk", category: "Snacks", price: 80, tags: ["premium"] },

  // Beverages
  { name: "tea", brand: "Tata Tea", category: "Beverages", price: 15, tags: [] },
  { name: "coffee", brand: "Nescafe", category: "Beverages", price: 20, tags: [] },
  { name: "juice", brand: "Real", category: "Beverages", price: 45, tags: [] },
  { name: "soft drinks", brand: "Coca Cola", category: "Beverages", price: 45, tags: [] },
  { name: "coconut water", brand: "Raw Pressery", category: "Beverages", price: 55, tags: ["healthy"] },
  { name: "buttermilk", brand: "Amul", category: "Beverages", price: 25, tags: ["summer"] },

  // Grocery/Staples
  { name: "rice", brand: "India Gate", category: "Grocery/Staples", price: 70, tags: [] },
  { name: "flour", brand: "Aashirvaad", category: "Grocery/Staples", price: 45, tags: [] },
  { name: "sugar", brand: "SugarLite", category: "Grocery/Staples", price: 50, tags: [] },
  { name: "salt", brand: "Tata Salt", category: "Grocery/Staples", price: 20, tags: [] },
  { name: "oil", brand: "Fortune", category: "Grocery/Staples", price: 140, tags: [] },
  { name: "honey", brand: "Dabur", category: "Grocery/Staples", price: 110, tags: ["healthy"] },
  { name: "jaggery", brand: "OrganicIndia", category: "Grocery/Staples", price: 45, tags: ["organic"] },

  // Personal Care (new category)
  { name: "toothpaste", brand: "Colgate", category: "Personal Care", price: 55, tags: [] },
  { name: "toothpaste", brand: "Pepsodent", category: "Personal Care", price: 45, tags: [] },
  { name: "shampoo", brand: "Head & Shoulders", category: "Personal Care", price: 130, tags: [] },
  { name: "soap", brand: "Dove", category: "Personal Care", price: 60, tags: ["premium"] },
  { name: "handwash", brand: "Dettol", category: "Personal Care", price: 75, tags: [] },
];
